import { lazy } from 'react';

import Loadable from 'components/Loadable';
import DefaultRouteErrorBoundary from 'components/error-boundary/DefaultRouteErrorBoundary';
import PrivateOutlet from 'routes/PrivateOutlet';
import MainLayout from 'layout/MainLayout/MainLayout';
import NavigationScroll from './NavigationScroll';

import ModuleRoutes from './Module.route';
import ComptrollerRoutes from './Comptroller.route';
import DashboardRootRoutes from './DashboardRoot.route';
import StaticSolutionRoutes from './StaticSolution.route';
import AdministrationRoutes from './Administration.route';

// import Career from 'sections/landing/Career';
import DemoBlock from 'sections/landing/DemoBlock';
import PartnerBlock from 'sections/landing/PartnerBlock';
import ElementBlock from 'sections/landing/ElementBlock';

import OurUniqueness from 'sections/landing/OurUniqueness';
import TestimonialBlock from 'sections/landing/TestimonialBlock';
import LandingPageLayout from 'sections/landing/LandingPageLayout';

const SocketPlayground = Loadable(lazy(() => import('components/socket-playground/SocketPlayground')));
const NotFound = Loadable(lazy(() => import('pages/notFound/NotFound')));
const HomePage = Loadable(lazy(() => import('pages/public-page/HomePage')));
const AboutPage = Loadable(lazy(() => import('pages/public-page/AboutPage')));
const BlogPage = Loadable(lazy(() => import('pages/public-page/BlogPage')));
const BlogDetailsPage = Loadable(lazy(() => import('pages/public-page/BlogDetailsPage')));
const CareerPage = Loadable(lazy(() => import('pages/public-page/CareerPage')));
const ContactPage = Loadable(lazy(() => import('pages/public-page/ContactPage')));
const CareerDetailsPage = Loadable(lazy(() => import('pages/public-page/CareerDetailsPage')));
const SolutionDetailsPage = Loadable(lazy(() => import('pages/public-page/SolutionDetailsPage')));

const MainRoutesObject = {
	path: '/',
	element: <NavigationScroll />,
	errorElement: <DefaultRouteErrorBoundary />,
	children: [
		{
			element: <PrivateOutlet />,
			children: [
				{
					element: <MainLayout />,
					children: [
						{ path: 'socket', element: <SocketPlayground /> },
						...DashboardRootRoutes,
						...StaticSolutionRoutes,
						...AdministrationRoutes,
						...ComptrollerRoutes,
						...ModuleRoutes,
						{ path: '*', element: <NotFound /> },
					],
				},
			],
		},
	],
};
export { MainRoutesObject };
